import { Injectable } from '@angular/core';

import { CssStyle, ExternalUrl } from '../../constants/constants';
import { AppConfig } from '../../dtos/app-config';
import { BrandEnum } from '../../dtos/enum';

declare const _appConfig: AppConfig;

@Injectable()
export class ConfigHelper {

  private baseUrl: string;

  constructor() {
    this.baseUrl = _appConfig.baseUrl;
  }

  getBaseUrl(): string {
    return this.baseUrl;
  }

  getApiUrl(path: string): string {
    return `${this.getBaseUrl()}/api/${path}`;
  }

  getBrandId(): BrandEnum {
    return Number(_appConfig.brandId) as BrandEnum;
  }

  getFaceBookPixelId() {
    return _appConfig.facebookPixelAnalyticsId;
  }

  getLaunchSoringTimelineSwitch() {
    return _appConfig.launchScoringTimelineSwitch;
  }

  getBrandName(): string {
    return _appConfig.brandName;
  }

  getRecaptchaSiteKey(): string {
    return _appConfig.recaptchaSiteKey;
  }

  getHcaptchaSiteKey(): string {
    return _appConfig.hcaptchaSiteKey;
  }

  getLaunchSRDownload(): number {
    return Number(_appConfig.launchSRDownload);
  }

  getWordPressUrl() {
    return ExternalUrl.WORD_PRESS_MAP.get(this.getBrandId()) ?? "";
  }

  getTestTypeCssClass(testTypeId: number) {
    return CssStyle.TEST_TYPE_MAP.get(testTypeId) ?? "";
  }

  getProductImageUrl(imageUrl: string): string {
    if (!imageUrl) {
      return this.getBaseUrl() + "/Content/img/product/tempImage.png";
    }
    if (this.isWordpressURL(imageUrl)) {
      return imageUrl;
    } else {
      return this.getBaseUrl() + "/Content/img/product/" + imageUrl;
    }
  }

  isWordpressURL(imageUrl: string): boolean {
    const regex = /^http[s]?:\/\/(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
    return regex.test(imageUrl);
  }

  getRegPoliciesUrl(): string {
    return _appConfig.regPoliciesUrl;
  }
  getTestDayInfoUrl(): string {
    return _appConfig.testDayInfoUrl;
  }

  getImageUrl(imageUrl: string): string {
    return this.getBaseUrl() + "/Content/img/" + imageUrl;
  }

  getPdfUrl(pdfUrl: string) {
    return this.getBaseUrl() + "/Content/img/product/" + pdfUrl + "#toolbar=0";
  }

}
